import { Component, EventEmitter, OnDestroy, OnInit, Output, ChangeDetectorRef, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  buildHeaderDataShell,
  generalConfigFromGlobal,
  normalizeFilterParams,
  rowPayloadFromActiveScreen,
  gridPayloadFromActiveScreen,
} from '../../../shared/workspace-element-context';
import { OtherOverridesDeleteService } from './other-overrides-delete.service';

@Component({
    selector: 'gtw-other-overrides-delete',
    templateUrl: './other-overrides-delete.component.html',
    styleUrls: ['./other-overrides-delete.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class OtherOverridesDeleteComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  private readonly subs = new Subscription();

  // Standard component properties
  minimise = false;
  crudLoading = false;

  // Modal title
  modalTitle = "Delete Override";

  // Component state
  isDelete = true;
  rowData: any = {};
  colData: any = {};
  gridData: any = {};
  filterParams: any = {};
  globalService: any = {};
  globalParams: any = {};
  GENERAL_CONFIG: any = {};
  USER_SETTINGS: any = {};
  baseURLs: any = {};

  // Row data properties
  ho_leid: string = '';
  ho_cdr_no: string = '';
  ho_combination_key: string = '';
  logged_in_user: string = '';

  constructor(
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService,
    private otherOverridesDeleteService: OtherOverridesDeleteService,
    private _snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(this.gtwWorkspace.setTabActive.subscribe(() => {
      this.applyWorkspaceContext();
      this.init();
    }));
    this.subs.add(this.gtwGlobal.globalParamsChanged$.subscribe(() => {
      this.applyWorkspaceContext();
      this.init();
    }));
    this.init();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const header = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    this.baseURLs = generalConfigFromGlobal(this.gtwGlobal);
    this.GENERAL_CONFIG = header.generalConfigData || {};
    this.USER_SETTINGS = header.userSettingsData || {};
    this.globalParams = header.globalParams || {};
    this.globalService = this.globalParams;
    this.filterParams = normalizeFilterParams(activeScreen);
    const row = rowPayloadFromActiveScreen(activeScreen);
    this.rowData = Array.isArray(row) ? (row[0] || {}) : row;
    this.gridData = gridPayloadFromActiveScreen(activeScreen) || {};
    this.colData =
      activeScreen?.data?.colData || activeScreen?.data?.col_data || {};
    this.logged_in_user = this.USER_SETTINGS.user?.sso_id || '';
    this.syncRowDerivedFields();
  }

  private syncRowDerivedFields(): void {
    this.ho_leid = this.rowData.HO_LEID || '';
    this.ho_cdr_no = this.rowData.HO_CDR_NO || '';
    this.ho_combination_key = this.rowData.HO_COMBINATION_KEY || '';
  }

  init() {
    try {
      const hasFilterParams = this.filterParams && Object.keys(this.filterParams).length > 0;
      const hasRowData = this.rowData && Object.keys(this.rowData).length > 0;

      if (hasFilterParams && hasRowData) {
        console.log("Here is the starting point and the rowData was ::::::::", this.rowData);
        console.log("Here is the starting point and the global Params was ::::::::", this.globalParams);
      }
    } catch (e) {
      console.error('Error in OtherOverridesDelete init:', e);
    }
  }

  deletePayment() {
    if (!this.rowData.ADJ_KEY) {
      this._snackBar.open('Invalid adjustment data', 'Close', {
        duration: 4000,
        panelClass: ['error-snackbar']
      });
      return;
    }

    const paymentJson = { adj_key: this.rowData.ADJ_KEY };
    const clob_settings = [{
      sso_id: this.logged_in_user,
      screen_key: this.globalParams.screen_key || this.filterParams.screen_key,
      adj_key: this.rowData.ADJ_KEY
    }];
    const success_message = "The Part and section Override was successfully deleted";

    console.log("The save json data was :::::", paymentJson);
    console.log("globalParams for delete:", this.globalParams);
    console.log("filterParams for delete:", this.filterParams);

    this.crudLoading = true;

    this.otherOverridesDeleteService.deletePayment(
      this.GENERAL_CONFIG.base_url,
      paymentJson,
      clob_settings,
      this.logged_in_user,
      this.globalParams,
      this.filterParams,
      this.rowData
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        console.log("Result from rep Trans save data was ---------------::::", response);
        this.crudLoading = false;

        if (response.errorMessage && response.errorMessage !== 'null') {
          console.log("There was the error message and the message is ", response.errorMessage);
          this._snackBar.open(response.errorMessage, 'Close', {
            duration: 4000,
            panelClass: ['error-snackbar']
          });
        } else {
          console.log("There wa no error message and the message was ", response.errorMessage);
          this._snackBar.open(success_message, 'Close', {
            duration: 4000,
            panelClass: ['success-snackbar']
          });

          this.requestGridUpdate.emit('refresh');
        }
      },
      (error: any) => {
        this.crudLoading = false;
        console.error('Error deleting payment:', error);
        this._snackBar.open('Error occurred while deleting. Please try again.', 'Close', {
          duration: 4000,
          panelClass: ['error-snackbar']
        });
      }
    );
  }

  cancel() {
    this.crudLoading = false;
    console.log("in cancel");
    this.requestGridUpdate.emit('cancel');
  }
}
